// extracted by mini-css-extract-plugin
export const light = "App-module--light--3A2i_";
export const dark = "App-module--dark--vtUiU";
export const container = "App-module--container--M4Taf";